import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ReactComponent as VatWhiteIcon } from '@pkg/components/Sections/Profile/icons/yat.svg';

export const StyledLoader = styled(motion(VatWhiteIcon))`
    position: absolute;
    width: 40px;
    transform-origin: center bottom;
`;
